import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { projectTitleInitialState } from '../reducers/project-title';

import MEMUComponent from '../components/menu-bar/menu-bar.jsx';

/**
 * Project saver component passes a downloadProject function to its child.
 * It expects this child to be a function with the signature
 *     function (downloadProject, props) {}
 * The component can then be used to attach project saving functionality
 * to any other component:
 *
 * <SB3Downloader>{(downloadProject, props) => (
 *     <MyCoolComponent
 *         onClick={downloadProject}
 *         {...props}
 *     />
 * )}</SB3Downloader>
 */

class SB3Downloader extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'downloadProject'
        ]);
    }
    downloadProject() {
        // 判断是否是python编辑区还是积木区
        if (this.props.showtitle) {
            const downloadLink = document.createElement('a');
            document.body.appendChild(downloadLink);

            this.props.saveProjectSb3().then(content => {
                if (this.props.onSaveFinished) {
                    this.props.onSaveFinished();
                }
                // Use special ms version if available to get it working on Edge.
                if (navigator.msSaveOrOpenBlob) {
                    navigator.msSaveOrOpenBlob(content, this.props.projectFilename);
                    return;
                }

                const url = window.URL.createObjectURL(content);
                downloadLink.href = url;
                downloadLink.download = this.props.projectFilename;
                const projectFilename = this.props.projectFilename;
                downloadLink.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(downloadLink);

            });
        } else {
            const inputPyDom = document.createElement('a')
            const url = window.URL.createObjectURL(new Blob([this.props.monacodeValue]))
            inputPyDom.download = this.props.projectFilename.split('.')[0] + '.py';
            inputPyDom.href = url
            inputPyDom.click()
            window.URL.revokeObjectURL(url)
            inputPyDom.remove()
        }

    }
    render() {
        const {
            children,
            ...componentProps
        } = this.props;
        return children(
            this.props.className,
            this.downloadProject,
            <MEMUComponent
                {...componentProps}
            >
                {children}
            </MEMUComponent>
        );
    }
}

const getProjectFilename = (curTitle, defaultTitle) => {
    let filenameTitle = curTitle;
    if (!filenameTitle || filenameTitle.length === 0) {
        filenameTitle = defaultTitle;
    }
    return `${filenameTitle.substring(0, 100)}.sb3`;
};

SB3Downloader.propTypes = {
    children: PropTypes.func,
    className: PropTypes.string,
    onSaveFinished: PropTypes.func,
    projectFilename: PropTypes.string,
    saveProjectSb3: PropTypes.func,
    showtitle: PropTypes.bool,
    monacodeValue: PropTypes.string
};
SB3Downloader.defaultProps = {
    className: ''
};

const mapStateToProps = state => ({
    saveProjectSb3: state.scratchGui.vm.saveProjectSb3.bind(state.scratchGui.vm),
    projectFilename: getProjectFilename(state.scratchGui.projectTitle.title, projectTitleInitialState),
    showtitle: state.scratchGui.menus.showtitle,
    monacodeValue: state.scratchGui.monacodes.value

});

export default connect(
    mapStateToProps,
    () => ({}) // omit dispatch prop
)(SB3Downloader);
